// Melding op het bord als het gezinsbord verwijderd gaat worden (0036). Duitse tegenhanger.
export const kioskPrivacyDe = {
    closingTitle: 'Diese Tafel endet am {date}',
    closingBody: 'Stimmt das nicht? Frag einen Elternteil: In der App lässt es sich noch stoppen.',
};
//# sourceMappingURL=kioskPrivacy.de.js.map